module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/mediumFaceIcon.80a69cb1.svg";